<template>
    <div class="signup container">
        <div class="row card-panel" style="padding: 30px;">
            <div class="col-12">
                <div class="row" style="margin-top: 35px">
                    <div class="col-12 center">
                        <i class="teal-text material-icons" style="font-size: 3em;">check_circle</i>
                        <p>A login link has been sent to: <span class="teal-text" style="font-size: 1.4em;">{{ email }}</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailLink',
    data() {
        return {
            email: window
        }
    },
    methods: {

    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        this.email = urlParams.get('e');
    }
}
</script>

<style scoped>
    .signup {
        max-width: 400px;
        margin-top: 60px;;
    }
    .signup h2 {
        font-size: 1.4em;
    }
    .signup .field{
        margin-bottom: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/auth/EmailLink.vue